import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0bf037d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "boot-optimize-wrap" }

import { ref, reactive, computed, onMounted, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import Card from '@/views/dashboard/_components/card/card.vue'
import StatisticsCards from './_components/statistics-cards.vue'
import BootTypeDistributionChart from './_components/boot-type-distribution-chart.vue'
import ActiveTerminalRankingChart from './_components/active-terminal-ranking-chart.vue'
import BootListTop10 from './_components/boot-list-top10/boot-list-top10.vue'
import TerminalListTop10 from './_components/terminal-list-top10/terminal-list-top10.vue'
import TrustList from './_components/trust-list/trust-list.vue'
import TerminalDetailDrawer from './_components/terminal-detail-drawer/terminal-detail-drawer.vue'
import BootItemDetailDrawer from './_components/boot-item-detail-drawer/boot-item-detail-drawer.vue'
import { BootOptimizeService } from './service'
import { BootViewService, BootItem } from './_components/boot-view/boot-view.service'
import { TerminalViewService, TerminalItem } from './_components/terminal-view/terminal-view.service'
import { TableViewMode } from '@/views/dashboard/_enum/table-view-mode'
import type { BootListInitialQueryPatch } from './_components/boot-list-top10/boot-list-top10.vue'
import type { TerminalListInitialQueryPatch } from './_components/terminal-list-top10/terminal-list-top10.vue'
import type { BootOptimizeStatCardKey } from './_components/boot-optimize-statistics-cards.types'


export default /*#__PURE__*/_defineComponent({
  __name: 'boot-optimize',
  setup(__props) {

const { t } = useI18n()

/** 顶栏统计卡（statistics-events：指标为 0 不可点） */
function handleBootOptimizeStatClick(key: BootOptimizeStatCardKey) {
  if (key === 'totalBootItems') {
    if (statistics.totalBootItems <= 0) return
    viewAllBootItems()
    return
  }
  if (statistics.trustedBootItems <= 0) return
  viewAllTrustList()
}

const injector = useReflectiveInjector([BootOptimizeService, TerminalViewService])
const bootOptimizeService = injector.get(BootOptimizeService)
const terminalService = injector.get(TerminalViewService)

// 统计数据
const statistics = reactive({
  totalBootItems: 0,
  trustedBootItems: 0
})

// 图表数据
const bootTypeData = ref<Array<{ autorun_type: number; count: number }>>([])
const activeTerminalData = ref<Array<{ startup_item_name: number; startup_item_count: number }>>([])

// 抽屉状态
const bootListDrawerVisible = ref(false)
const terminalListDrawerVisible = ref(false)
const trustListDrawerVisible = ref(false)

const bootListDrawerKey = ref(0)
const bootListDrawerInitialPatch = ref<BootListInitialQueryPatch | undefined>(undefined)
const bootListDrawerTitleBracket = ref('')

const bootListDrawerTitle = computed(() => {
  const base = t('bootOptimize.bootList')
  const br = bootListDrawerTitleBracket.value.trim()
  return br ? `${base} [${br}]` : base
})

const terminalListDrawerKey = ref(0)
const terminalListDrawerInitialPatch = ref<TerminalListInitialQueryPatch | undefined>(undefined)
const terminalListDrawerTitleBracket = ref('')

const terminalListDrawerTitle = computed(() => {
  const base = t('bootOptimize.terminalList')
  const br = terminalListDrawerTitleBracket.value.trim()
  return br ? `${base} [${br}]` : base
})

const bootItemDetailDrawer = reactive({
  drawer: false,
  direction: 'rtl' as 'rtl' | 'ltr' | 'ttb' | 'btt',
  baseInfo: {} as BootItem,
  initialTab: 'optimized-terminal' as 'optimized-terminal' | 'unoptimized-terminal'
})

const terminalDetailDrawer = reactive({
  drawer: false,
  direction: 'rtl' as 'rtl' | 'ltr' | 'ttb' | 'btt',
  baseInfo: {} as TerminalItem,
  initialTab: 'active-boot-item' as 'active-boot-item' | 'unoptimized-item' | 'optimized-item'
})

// 加载统计数据
async function loadStatistics() {
  try {
    const res = await bootOptimizeService.getTerminalStartupItemStat()
    statistics.totalBootItems = res.startup_item_count || 0
    statistics.trustedBootItems = res.trusted_startup_item_count || 0
  } catch (error) {
    console.error('加载统计数据失败:', error)
  }
}

// 加载图表数据
async function loadChartData() {
  if (activeTerminalRankingChartRef.value) {
    activeTerminalRankingChartRef.value.loading = true
  }
  try {
    const res = await bootOptimizeService.getTerminalStartupItemStat()

    // 启动项类型统计
    bootTypeData.value = res.startup_item_type_stat_top5 || []

    // 活跃启动终端TOP5
    activeTerminalData.value = res.active_startup_item_top5 || []
  } catch (error) {
    console.error('加载图表数据失败:', error)
    bootTypeData.value = []
    activeTerminalData.value = []
  } finally {
    if (activeTerminalRankingChartRef.value) {
      activeTerminalRankingChartRef.value.loading = false
    }
  }
}

// 启动项详情相关
function showBootItemDetail({ row, optimized }: { row: BootItem; optimized: number }) {
  bootItemDetailDrawer.baseInfo = row
  bootItemDetailDrawer.initialTab = optimized === 1 ? 'optimized-terminal' : 'unoptimized-terminal'
  bootItemDetailDrawer.drawer = true
}

function handleBootItemDrawerClose() {
  bootItemDetailDrawer.drawer = false
}

const activeTerminalRankingChartRef = ref()

// 终端详情相关
function showTerminalDetail({ row, optimized }: { row: TerminalItem; optimized: number }) {
  terminalDetailDrawer.baseInfo = row
  // 映射 optimized 参数到对应的 tab
  // optimized: 0 -> 'active-boot-item', 1 -> 'optimized-item', 2 -> 'unoptimized-item'
  if (optimized === 0) {
    terminalDetailDrawer.initialTab = 'active-boot-item'
  } else if (optimized === 1) {
    terminalDetailDrawer.initialTab = 'optimized-item'
  } else if (optimized === 2) {
    terminalDetailDrawer.initialTab = 'unoptimized-item'
  }
  terminalDetailDrawer.drawer = true
}

function viewAllBootItems() {
  bootListDrawerInitialPatch.value = undefined
  bootListDrawerTitleBracket.value = ''
  bootListDrawerKey.value += 1
  bootListDrawerVisible.value = true
}

function onBootTypeChartRowClick(payload: { autorun_type: number; name: string }) {
  bootListDrawerInitialPatch.value = { autorun_type: payload.autorun_type }
  bootListDrawerTitleBracket.value = payload.name
  bootListDrawerKey.value += 1
  bootListDrawerVisible.value = true
}

function viewAllTerminals() {
  terminalListDrawerInitialPatch.value = undefined
  terminalListDrawerTitleBracket.value = ''
  terminalListDrawerKey.value += 1
  terminalListDrawerVisible.value = true
}

function onActiveStartupItemChartRowClick(item: { name?: string | number; count?: number }) {
  const kw = String(item.name ?? '').trim()
  bootListDrawerInitialPatch.value = kw ? { key_word: kw } : undefined
  bootListDrawerTitleBracket.value = kw
  bootListDrawerKey.value += 1
  bootListDrawerVisible.value = true
}

function viewAllTrustList() {
  trustListDrawerVisible.value = true
}

onMounted(async () => {
  await nextTick()
  loadStatistics()
  loadChartData()
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(StatisticsCards, {
      "total-boot-items": statistics.totalBootItems,
      "trusted-boot-items": statistics.trustedBootItems,
      onStatClick: handleBootOptimizeStatClick
    }, null, 8, ["total-boot-items", "trusted-boot-items"]),
    _createVNode(_component_el_row, {
      gutter: 16,
      class: "charts-row"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(BootTypeDistributionChart, {
              "raw-data": bootTypeData.value,
              style: {"height":"100%"},
              onTypeClick: onBootTypeChartRowClick
            }, null, 8, ["raw-data"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(ActiveTerminalRankingChart, {
              ref_key: "activeTerminalRankingChartRef",
              ref: activeTerminalRankingChartRef,
              data: activeTerminalData.value,
              onItemClick: onActiveStartupItemChartRowClick
            }, null, 8, ["data"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(Card, {
      size: "second",
      class: "cm-ui-mt16",
      title: _ctx.$t('bootOptimize.bootListTop10')
    }, {
      titleAfter: _withCtx(() => [
        _createVNode(_component_el_tag, { size: "small" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.listPreviewRecent10')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(BootListTop10, {
          "view-mode": _unref(TableViewMode).preview,
          onDetail: showBootItemDetail,
          onRefresh: loadStatistics,
          onViewAll: viewAllBootItems
        }, null, 8, ["view-mode"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(Card, {
      size: "second",
      class: "cm-ui-mt16",
      title: _ctx.$t('bootOptimize.terminalListTop10')
    }, {
      titleAfter: _withCtx(() => [
        _createVNode(_component_el_tag, { size: "small" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.listPreviewRecent10')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(TerminalListTop10, {
          "view-mode": _unref(TableViewMode).preview,
          onDetail: showTerminalDetail,
          onViewAll: viewAllTerminals
        }, null, 8, ["view-mode"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(Card, {
      size: "second",
      class: "cm-ui-mt16",
      title: _ctx.$t('bootOptimize.trustList')
    }, {
      default: _withCtx(() => [
        _createVNode(TrustList, {
          "view-mode": _unref(TableViewMode).preview,
          onRefresh: loadStatistics,
          onViewAll: viewAllTrustList
        }, null, 8, ["view-mode"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_el_drawer, {
      modelValue: bootListDrawerVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((bootListDrawerVisible).value = $event)),
      size: "80%",
      title: bootListDrawerTitle.value,
      "destroy-on-close": "",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(BootListTop10, {
          key: bootListDrawerKey.value,
          "view-mode": _unref(TableViewMode).full,
          "initial-query-patch": bootListDrawerInitialPatch.value,
          style: {"padding":"10px 16px"},
          onDetail: showBootItemDetail,
          onRefresh: loadStatistics
        }, null, 8, ["view-mode", "initial-query-patch"]))
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_drawer, {
      modelValue: terminalListDrawerVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((terminalListDrawerVisible).value = $event)),
      size: "80%",
      title: terminalListDrawerTitle.value,
      "destroy-on-close": "",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(TerminalListTop10, {
          key: terminalListDrawerKey.value,
          "view-mode": _unref(TableViewMode).full,
          "initial-query-patch": terminalListDrawerInitialPatch.value,
          style: {"padding":"10px 16px"},
          onDetail: showTerminalDetail
        }, null, 8, ["view-mode", "initial-query-patch"]))
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_drawer, {
      modelValue: trustListDrawerVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((trustListDrawerVisible).value = $event)),
      size: "80%",
      title: _ctx.$t('bootOptimize.trustList'),
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(TrustList, {
          "view-mode": _unref(TableViewMode).full,
          style: {"padding":"10px 16px"},
          onRefresh: loadStatistics
        }, null, 8, ["view-mode"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(BootItemDetailDrawer, {
      modelValue: bootItemDetailDrawer.drawer,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((bootItemDetailDrawer.drawer) = $event)),
      "base-info": bootItemDetailDrawer.baseInfo,
      direction: bootItemDetailDrawer.direction,
      "initial-tab": bootItemDetailDrawer.initialTab,
      onClose: handleBootItemDrawerClose
    }, null, 8, ["modelValue", "base-info", "direction", "initial-tab"]),
    _createVNode(TerminalDetailDrawer, {
      modelValue: terminalDetailDrawer.drawer,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((terminalDetailDrawer.drawer) = $event)),
      "base-info": terminalDetailDrawer.baseInfo,
      direction: terminalDetailDrawer.direction,
      "initial-tab": terminalDetailDrawer.initialTab
    }, null, 8, ["modelValue", "base-info", "direction", "initial-tab"])
  ]))
}
}

})